import React, { Component } from "react";
class Language extends Component {
  constructor(props) {
    super(props);
    this.state = { result: "" };
  }
  render() {
    switch (this.props.mode) {
      default:
        return (
          <div key={this.props.language}>
            {this.state.result.split("\n").map((str) => (
              <span>
                {str}
                <br />
              </span>
            ))}
          </div>
        );
      case "list":
        return (
          <div key={this.props.language}>
            <ul style={{ listStylePosition: "outside" }}>
              {this.state.result.split("\n").map((str) => (
                <li style={{ margin: this.props.listSpace }}>{str}</li>
              ))}
            </ul>
          </div>
        );
    }
  }
  //run on first time
  componentDidMount() {
    this.UpdateResult();
  }
  //rerun every update
  componentDidUpdate(prevProps) {
    if (prevProps.language != this.props.language || prevProps.section != this.props.section) {
      this.UpdateResult();
    }
  }
  UpdateResult() {
    //check if language is present when bug occors
    switch (this.props.section) {
      default:
        this.setState({ result: "section: " + this.props.section + " not found! please check ..." });
        break;
      //header
      case "navAboutUs":
        this.setState({ result: this.NavAboutUs(this.props.language) });
        break;
      case "navOurMinistries":
        this.setState({ result: this.NavOurMinistries(this.props.language) });
        break;
      case "navGetInvolved":
        this.setState({ result: this.NavGetInvolved(this.props.language) });
        break;
      case "navContactUs":
        this.setState({ result: this.NavContactUs(this.props.language) });
        break;
      //Bulletin
      case "bulletinSerojaCyclone":
        this.setState({ result: this.BulletinSerojaCyclone(this.props.language) });
        break;
      //Home
      case "mvaTitle":
        this.setState({ result: this.MVATitle(this.props.language) });
        break;
      case "bibleVerse":
        this.setState({ result: this.BibleVerse(this.props.language) });
        break;
      case "joinMVAButton":
        this.setState({ result: this.JoinMVAButton(this.props.language) });
        break;
      case "reportTitle":
        this.setState({ result: this.ReportTitle(this.props.language) });
        break;
      //AboutUs
      case "navHistory":
        this.setState({ result: this.NavHistory(this.props.language) });
        break;
      case "navWhoWeAre":
        this.setState({ result: this.NavWhoWeAre(this.props.language) });
        break;
      case "navPurpose":
        this.setState({ result: this.NavPurpose(this.props.language) });
        break;
      case "navArchitecture":
        this.setState({ result: this.NavArchitecture(this.props.language) });
        break;
      case "navStrategy":
        this.setState({ result: this.NavStrategy(this.props.language) });
        break;
      case "navOurVisions":
        this.setState({ result: this.NavOurVisions(this.props.language) });
        break;
      case "navOurMissions":
        this.setState({ result: this.NavOurMissions(this.props.language) });
        break;
      //OurMinistries
      case "navMalaysia":
        this.setState({ result: this.NavMalaysia(this.props.language) });
        break;
      case "navInternational":
        this.setState({ result: this.NavInternational(this.props.language) });
        break;
      case "navCovid19":
        this.setState({ result: this.NavCovid19(this.props.language) });
        break;
      case "navOngoing":
        this.setState({ result: this.NavOngoing(this.props.language) });
        break;
      case "navPublications":
        this.setState({ result: this.NavPublications(this.props.language) });
        break;
      //GetInvolved
      case "navMCRDVolunteer":
        this.setState({ result: this.NavMCRDVolunteer(this.props.language) });
        break;
      case "navMAcademy":
        this.setState({ result: this.NavMAcademy(this.props.language) });
        break;
      case "navPrayerSupport":
        this.setState({ result: this.NavPrayerSupport(this.props.language) });
        break;
      case "navOfferingSupport":
        this.setState({ result: this.NavOfferingSupport(this.props.language) });
        break;
      //AboutUsContent
      case "historyTitle":
        this.setState({ result: this.HistoryTitle(this.props.language) });
        break;
      case "historyContent":
        this.setState({ result: this.HistoryContent(this.props.language) });
        break;
      case "whoWeAreTitle":
        this.setState({ result: this.WhoWeAreTitle(this.props.language) });
        break;
      case "whoWeAreContent":
        this.setState({ result: this.WhoWeAreContent(this.props.language) });
        break;
      case "purposeTitle":
        this.setState({ result: this.PurposeTitle(this.props.language) });
        break;
      case "purposeContent":
        this.setState({ result: this.PurposeContent(this.props.language) });
        break;
      case "architectureTitle":
        this.setState({ result: this.ArchitectureTitle(this.props.language) });
        break;
      case "architectureMCRD":
        this.setState({ result: this.ArchitectureMCRD(this.props.language) });
        break;
      case "architectureDistributionBranchHeading":
        this.setState({ result: this.ArchitectureDistributionBranchHeading(this.props.language) });
        break;
      case "architectureDistributionBranch":
        this.setState({ result: this.ArchitectureDistributionBranch(this.props.language) });
        break;
      case "architectureIncidentCommandSystem":
        this.setState({ result: this.ArchitectureIncidentCommandSystem(this.props.language) });
        break;
      case "strategyTitle":
        this.setState({ result: this.StrategyTitle(this.props.language) });
        break;
      //ministries
      case "westMalaysiaMinistryTitle":
        this.setState({ result: this.WestMalaysiaMinistryTitle(this.props.language) });
        break;
      case "ministryHistoryTitle":
        this.setState({ result: this.MinistryHistoryTitle(this.props.language) });
        break;
      case "malaysiaTitle":
        this.setState({ result: this.MalaysiaTitle(this.props.language) });
        break;
      case "internationalTitle":
        this.setState({ result: this.InternationalTitle(this.props.language) });
        break;
      case "kelantan2015":
        this.setState({ result: this.Kelantan2015(this.props.language) });
        break;
      case "sarawak2017":
        this.setState({ result: this.Sarawak2017(this.props.language) });
        break;
      case "selangor2017":
        this.setState({ result: this.Selangor2017(this.props.language) });
        break;
      case "penang2017":
        this.setState({ result: this.Penang2017(this.props.language) });
        break;
      case "johor2019":
        this.setState({ result: this.Johor2019(this.props.language) });
        break;
      case "pahang2021":
        this.setState({ result: this.Pahang2021(this.props.language) });
        break;
      case "nepal2015":
        this.setState({ result: this.Nepal2015(this.props.language) });
        break;
      case "india2015":
        this.setState({ result: this.India2015(this.props.language) });
        break;
      case "myanmar2015":
        this.setState({ result: this.Myanmar2015(this.props.language) });
        break;
      case "india2018":
        this.setState({ result: this.India2018(this.props.language) });
        break;
      case "indonesia2018A":
        this.setState({ result: this.Indonesia2018A(this.props.language) });
        break;
      case "indonesia2018B":
        this.setState({ result: this.Indonesia2018B(this.props.language) });
        break;
      case "india2019":
        this.setState({ result: this.India2019(this.props.language) });
        break;
      //noncovid19
      case "nonCovid19Title":
        this.setState({ result: this.NonCovid19Title(this.props.language) });
        break;
      case "nonCovid19Malaysia1":
        this.setState({ result: this.NonCovid19Malaysia1(this.props.language) });
        break;
      //covid19
      case "covid19Title":
        this.setState({ result: this.Covid19Title(this.props.language) });
        break;
      case "covid19Malaysia1":
        this.setState({ result: this.Covid19Malaysia1(this.props.language) });
        break;
      case "covid19Malaysia2":
        this.setState({ result: this.Covid19Malaysia2(this.props.language) });
        break;
      case "covid19Malaysia3":
        this.setState({ result: this.Covid19Malaysia3(this.props.language) });
        break;
      case "covid19Malaysia4Title":
        this.setState({ result: this.Covid19Malaysia4Title(this.props.language) });
        break;
      case "covid19Malaysia4":
        this.setState({ result: this.Covid19Malaysia4(this.props.language) });
        break;
      case "covid19Nepal1Title":
        this.setState({ result: this.Covid19Nepal1Title(this.props.language) });
        break;
      case "covid19Nepal1":
        this.setState({ result: this.Covid19Nepal1(this.props.language) });
        break;
      case "covid19Nepal2Title":
        this.setState({ result: this.Covid19Nepal2Title(this.props.language) });
        break;
      case "covid19Nepal2":
        this.setState({ result: this.Covid19Nepal2(this.props.language) });
        break;
      case "covid19Nepal3Title":
        this.setState({ result: this.Covid19Nepal3Title(this.props.language) });
        break;
      case "covid19Nepal3":
        this.setState({ result: this.Covid19Nepal3(this.props.language) });
        break;
      //ongoing
      case "ongoingTitle":
        this.setState({ result: this.OngoingTitle(this.props.language) });
        break;
      case "ongoingBtn":
        this.setState({ result: this.OngoingBtn(this.props.language) });
        break;
      case "serojaCycloneFundTitle":
        this.setState({ result: this.SerojaCycloneFundTitle(this.props.language) });
        break;
      case "serojaCycloneFundContentA":
        this.setState({ result: this.SerojaCycloneFundContentA(this.props.language) });
        break;
      case "serojaCycloneFundContentB":
        this.setState({ result: this.SerojaCycloneFundContentB(this.props.language) });
        break;
      case "serojaCycloneFundContentC":
        this.setState({ result: this.SerojaCycloneFundContentC(this.props.language) });
        break;
      case "indiaCovid19FundTitle":
        this.setState({ result: this.IndiaCovid19FundTitle(this.props.language) });
        break;
      case "indiaCovid19FundContentA":
        this.setState({ result: this.IndiaCovid19FundContentA(this.props.language) });
        break;
      case "indiaCovid19FundContentB":
        this.setState({ result: this.IndiaCovid19FundContentB(this.props.language) });
        break;
      case "christmasGiftDonationTitle":
        this.setState({ result: this.ChristmasGiftDonationTitle(this.props.language) });
        break;
      case "christmasGiftDonationContentA":
        this.setState({ result: this.ChristmasGiftDonationContentA(this.props.language) });
        break;
      case "christmasGiftDonationContentB":
        this.setState({ result: this.ChristmasGiftDonationContentB(this.props.language) });
        break;
      case "bantuanBanjirFundraisingTitle":
        this.setState({ result: this.BantuanBanjirFundraisingTitle(this.props.language) });
        break;
      case "bantuanBanjirFundraisingContentA":
        this.setState({ result: this.BantuanBanjirFundraisingContentA(this.props.language) });
        break;
      case "bantuanBanjirFundraisingContentB":
        this.setState({ result: this.BantuanBanjirFundraisingContentB(this.props.language) });
        break;
      //get involved
      case "prayerSupportTitle":
        this.setState({ result: this.PrayerSupportTitle(this.props.language) });
        break;
      case "prayerSupportSubtitle":
        this.setState({ result: this.PrayerSupportSubtitle(this.props.language) });
        break;
      case "prayerContent":
        this.setState({ result: this.PrayerContent(this.props.language) });
        break;
      case "offeringSupportTitle":
        this.setState({ result: this.OfferingSupportTitle(this.props.language) });
        break;
      case "offeringSupportSubtitle":
        this.setState({ result: this.OfferingSupportSubtitle(this.props.language) });
        break;
    }
  }
  //navigation
  NavAboutUs = (e) => {
    switch (e) {
      case "eng":
        return "About us";
      case "chi":
        return "关于我们";
    }
  };
  NavOurMinistries = (e) => {
    switch (e) {
      case "eng":
        return "Our ministries";
      case "chi":
        return "我们的事工";
    }
  };
  NavGetInvolved = (e) => {
    switch (e) {
      case "eng":
        return "Get involved";
      case "chi":
        return "参与项目";
    }
  };
  NavContactUs = (e) => {
    switch (e) {
      case "eng":
        return "Contact us";
      case "chi":
        return "联系我们";
    }
  };
  //AboutUsNav
  NavHistory = (e) => {
    switch (e) {
      case "eng":
        return "History";
      case "chi":
        return "历史";
    }
  };
  NavWhoWeAre = (e) => {
    switch (e) {
      case "eng":
        return "Who we are";
      case "chi":
        return "我们是";
    }
  };
  NavPurpose = (e) => {
    switch (e) {
      case "eng":
        return "Purpose";
      case "chi":
        return "宗旨";
    }
  };
  NavArchitecture = (e) => {
    switch (e) {
      case "eng":
        return "Architecture";
      case "chi":
        return "架构";
    }
  };
  NavStrategy = (e) => {
    switch (e) {
      case "eng":
        return "Strategy";
      case "chi":
        return "策略";
    }
  };
  NavOurVisions = (e) => {
    switch (e) {
      case "eng":
        return "Our visions";
      case "chi":
        return "我们的展望";
    }
  };
  NavOurMissions = (e) => {
    switch (e) {
      case "eng":
        return "Our missions";
      case "chi":
        return "我们的任务";
    }
  };
  //Our Ministries
  NavMalaysia = (e) => {
    switch (e) {
      case "eng":
        return "Malaysia (local)";
      case "chi":
        return "马来西亚（国内）";
    }
  };
  NavInternational = (e) => {
    switch (e) {
      case "eng":
        return "International";
      case "chi":
        return "国外";
    }
  };
  NavCovid19 = (e) => {
    switch (e) {
      case "eng":
        return "Covid-19 responses";
      case "chi":
        return "新冠肺炎应对";
    }
  };
  NavOngoing = (e) => {
    switch (e) {
      case "eng":
        return "Ongoing";
      case "chi":
        return "正在进行中";
    }
  };
  NavPublications = (e) => {
    switch (e) {
      case "eng":
        return "All publications";
      case "chi":
        return "所有报导";
    }
  };
  //Get Involved
  NavMCRDVolunteer = (e) => {
    switch (e) {
      case "eng":
        return "MCRD volunteers";
      case "chi":
        return "MCRD 义工";
    }
  };
  NavMAcademy = (e) => {
    switch (e) {
      case "eng":
        return "Methodist volunteer academy";
      case "chi":
        return "卫理公会志愿者学校";
    }
  };
  NavPrayerSupport = (e) => {
    switch (e) {
      case "eng":
        return "Prayer support";
      case "chi":
        return "代祷支持";
    }
  };
  NavOfferingSupport = (e) => {
    switch (e) {
      case "eng":
        return "Offering support";
      case "chi":
        return "奉献支持";
    }
  };
  //bulletin
  BulletinSerojaCyclone = (e) => {
    switch (e) {
      case "eng":
        return "Fund Raising for East Nusa Tenggara Province(Seroja Cyclone Strike)";
      case "chi":
        return "为东努沙登加拉省筹款\n(“塞罗亚”热带气旋侵袭)";
    }
  };
  //home
  BibleVerse = (e) => {
    switch (e) {
      case "eng":
        return "The King will reply: Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me.\n(Mathew 25:40)";
      case "chi":
        return "王要回答说：我实在告诉你们，这些事你们既做在我这弟兄中一个最小的身上，就是做在我身上了。\n（马太福音 25：40）";
    }
  };
  MVATitle = (e) => {
    switch (e) {
      case "eng":
        return "Methodist Volunteer Academy";
      case "chi":
        return "卫理志愿者学校 (MVA)";
    }
  };
  JoinMVAButton = (e) => {
    switch (e) {
      case "eng":
        return "J\no\ni\nn";
      case "chi":
        return "前往报名";
    }
  };
  ReportTitle = (e) => {
    switch (e) {
      case "eng":
        return "Ministry Reports";
      case "chi":
        return "事工简报";
    }
  };
  //about us
  HistoryTitle = (e) => {
    switch (e) {
      case "eng":
        return "History";
      case "chi":
        return "历史";
    }
  };
  HistoryContent = (e) => {
    switch (e) {
      case "eng":
        return "Founded by Malaysia Methodist Chinese Anual Conference in December, 2014.";
      case "chi":
        return "由马来西亚基督教卫理公会华人年议会成立于二零一四年十二月。";
    }
  };
  WhoWeAreTitle = (e) => {
    switch (e) {
      case "eng":
        return "Who We Are";
      case "chi":
        return "我们是";
    }
  };
  WhoWeAreContent = (e) => {
    switch (e) {
      case "eng":
        return "Through volunteering service, skill building, and partnerships, we establish humanitarian work for both international and local country.\nRegardless of the boundaries of race, religion and nation, we provide imediate helps to victims in disasterous areas.\nIn Malaysia we serve any parties in need like B40, aboriginal, refugee. Internationally we serve victims in Nepal, India, Vietnam and Indonesia.";
      case "chi":
        return "我们透过志愿服务，能力建设和伙伴关系来发展及促进海内外的救援赈灾工作。\n我们不分种族、宗教和国籍及时提供适当的人道救援工作给受灾地区的灾民。\n我们在马来西亚服事有需要的团体，包括B40团体，原住民社区、难民社区以及在海外的需要者，如：尼泊尔，印度，缅甸和印度尼西亚。";
    }
  };
  PurposeTitle = (e) => {
    switch (e) {
      case "eng":
        return "Purpose";
      case "chi":
        return "宗旨";
    }
  };
  PurposeContent = (e) => {
    switch (e) {
      case "eng":
        return "Provide hamanitarian helps to the victims in disasterous areas regardles of race, religion, and nation.\nInitiate crisis and disaster relief, psychological consultations, training to enhance the awareness for natural disaster.\nFormation and building of volunteering team to be ready to deliver imediate helps in disasterous events.";
      case "chi":
        return "在灾难发生时，不分种族， 宗教与国籍提供给灾区的人民适时与适当的人道援助。\n举办灾难应对，危机处理， 灾难救援， 心理辅导等课程提高灾难警觉性。\n组织志愿者团队亲临灾区提供及时的援助。";
    }
  };
  ArchitectureTitle = (e) => {
    switch (e) {
      case "eng":
        return "Architecture";
      case "chi":
        return "组织架构";
    }
  };
  ArchitectureMCRD = (e) => {
    switch (e) {
      case "eng":
        return "MCRD Architecture";
      case "chi":
        return "MCRD 架构";
    }
  };
  ArchitectureDistributionBranchHeading = (e) => {
    switch (e) {
      case "eng":
        return "Local Coordination Group";
      case "chi":
        return "地方协调小组";
    }
  };
  ArchitectureDistributionBranch = (e) => {
    switch (e) {
      case "eng":
        return "West Malaysia\n•Penang •Semenanjung •Kepong •Ampang •Pandamaran •Sungai Rambai •Kuantan •Raub\n\nEast Malaysia\n•Sarawak •Sabah\n\nPartners\n•Nepal Methodist Crisis Relief and Development(NMCRD) •Sabah Methodist Crisis Relief and Development(SMCRD) •KELANTAN DISASTER RELIEF NETWORK(KDRN)";
      case "chi":
        return "西马\n•槟城 •曼绒 •甲洞 •安邦 •班达马兰 •双溪南眉 •关丹 •劳勿\n\n东马\n•砂拉越 •沙巴\n\n合作伙伴\n•尼泊尔卫理救援赈灾事工(NMCRD) •沙巴卫理救援赈灾事工(SMCRD) •吉兰丹救灾平台(KDRN)";
    }
  };
  ArchitectureIncidentCommandSystem = (e) => {
    switch (e) {
      case "eng":
        return "Incident Command System";
      case "chi":
        return "赈灾项目指挥系统";
    }
  };
  StrategyTitle = (e) => {
    switch (e) {
      case "eng":
        return "MCRD Total Disaster Risk Management Cycle";
      case "chi":
        return "MCRD 全面灾害风险管理";
    }
  };
  //ministries
  WestMalaysiaMinistryTitle = (e) => {
    switch (e) {
      case "eng":
        return "West-Malaysia Chinese Methodist Disaster Relief Ministries";
      case "chi":
        return "西马华人卫理救援赈灾事工";
    }
  };
  MinistryHistoryTitle = (e) => {
    switch (e) {
      case "eng":
        return "Ministry History";
      case "chi":
        return "事工简历";
    }
  };
  MalaysiaTitle = (e) => {
    switch (e) {
      case "eng":
        return "Malaysia";
      case "chi":
        return "马来西亚";
    }
  };
  InternationalTitle = (e) => {
    switch (e) {
      case "eng":
        return "International";
      case "chi":
        return "国外";
    }
  };
  Kelantan2015 = (e) => {
    switch (e) {
      case "eng":
        return "Kelantan Flood";
      case "chi":
        return "吉兰丹水灾";
    }
  };
  Sarawak2017 = (e) => {
    switch (e) {
      case "eng":
        return "Sarawak, Miri Flood";
      case "chi":
        return "砂拉越，美里水灾";
    }
  };
  Selangor2017 = (e) => {
    switch (e) {
      case "eng":
        return "Selangor, Kundang and Rawang Flood";
      case "chi":
        return "雪兰莪，昆当 万挠水灾";
    }
  };
  Penang2017 = (e) => {
    switch (e) {
      case "eng":
        return "Penang Flood";
      case "chi":
        return "槟城水灾";
    }
  };
  Johor2019 = (e) => {
    switch (e) {
      case "eng":
        return "Johor, Mersing Flood";
      case "chi":
        return "柔佛，合并水灾";
    }
  };
  Pahang2021 = (e) => {
    switch (e) {
      case "eng":
        return "Pahang, Benta Flood";
      case "chi":
        return "彭亨，文达水灾";
    }
  };
  Nepal2015 = (e) => {
    switch (e) {
      case "eng":
        return "Nepal Earthquake";
      case "chi":
        return "尼泊尔地震";
    }
  };
  India2015 = (e) => {
    switch (e) {
      case "eng":
        return "India, Chennai Flood";
      case "chi":
        return "印度，金奈水灾";
    }
  };
  Myanmar2015 = (e) => {
    switch (e) {
      case "eng":
        return "Myanmar, Segain and Chin Flood";
      case "chi":
        return "缅甸，实皆 即钦水灾";
    }
  };
  India2018 = (e) => {
    switch (e) {
      case "eng":
        return "India, Kerala Flood";
      case "chi":
        return "印度，喀拉拉水灾";
    }
  };
  Indonesia2018A = (e) => {
    switch (e) {
      case "eng":
        return "Indonesia, Lombok Earthquake";
      case "chi":
        return "印尼，龙目地震";
    }
  };
  Indonesia2018B = (e) => {
    switch (e) {
      case "eng":
        return "Indonesia, Sulawesi Earthquake, Tsunami";
      case "chi":
        return "印尼，苏拉威西地震，海啸";
    }
  };
  India2019 = (e) => {
    switch (e) {
      case "eng":
        return "India, Kerala Flood";
      case "chi":
        return "印度，喀拉拉水灾";
    }
  };
  //noncovid19
  NonCovid19Title = (e) => {
    switch (e) {
      case "eng":
        return "Non Covid-19 Response Ministries";
      case "chi":
        return "非新冠病毒应对事工";
    }
  };
  NonCovid19Malaysia1 = (e) => {
    switch (e) {
      case "eng":
        return "2021 Fund Raising Ministries and Organizations";
      case "chi":
        return "2021年拨款帮助事工于组织";
    }
  };
  //covid19
  Covid19Title = (e) => {
    switch (e) {
      case "eng":
        return "Covid-19 Response Ministries";
      case "chi":
        return "新冠病毒应对事工";
    }
  };
  Covid19Malaysia1 = (e) => {
    switch (e) {
      case "eng":
        return "Frontline Fund Support";
      case "chi":
        return "前线医护资助";
    }
  };
  Covid19Malaysia2 = (e) => {
    switch (e) {
      case "eng":
        return "Refugee Health Fund";
      case "chi":
        return "原住民医疗资助";
    }
  };
  Covid19Malaysia3 = (e) => {
    switch (e) {
      case "eng":
        return "Food supplied to B40, Aboriginal, Refugee";
      case "chi":
        return "B40，原住民，难民群体食物补给";
    }
  };
  Covid19Malaysia4Title = (e) => {
    switch (e) {
      case "eng":
        return "Sabah Ministries";
      case "chi":
        return "沙巴抗疫事工";
    }
  };
  Covid19Malaysia4 = (e) => {
    switch (e) {
      case "eng":
        return "5700 Gown distributed to several hospitals.\n8 Laptops sponsored to SPM Students.\n2215 Food Supply given to stateless family.";
      case "chi":
        return "5700 件隔离衣分发至各家医院。\n8 台电脑捐送给 SPM会考生。\n2215 份食物分发给无国籍家庭。";
    }
  };
  Covid19Nepal1Title = (e) => {
    switch (e) {
      case "eng":
        return "Nepal Pahse 1";
      case "chi":
        return "泥泊尔第一阶段";
    }
  };
  Covid19Nepal1 = (e) => {
    switch (e) {
      case "eng":
        return "Food supplied to 213 families.\nFood supplied to one orphanage home with 20 children.\nFinancial support to 50 pastors.";
      case "chi":
        return "食物补给至 213 个家庭。\n食物补给至拥有 20 个孩童的孤儿院。\n财务资助 50 名牧者。";
    }
  };
  Covid19Nepal2Title = (e) => {
    switch (e) {
      case "eng":
        return "Nepal Pahse 2";
      case "chi":
        return "泥泊尔第二阶段";
    }
  };
  Covid19Nepal2 = (e) => {
    switch (e) {
      case "eng":
        return "Food supplied to 351 families.\nFinancial support to Children Home with 15 children.\nFinancial support to 3 families of flood survivor.\nFinancial support to one pastor.\nFace Mask supplied to one orphanage home with 20 children.";
      case "chi":
        return "食物补给给 351 个家庭。\n财务资助一所共有 15 名孩童的儿童之家。\n财务资助 3 个水灾难民的家庭。\n财务资助一名牧者。\n口罩补给至一所共有 20 名孩子的孤儿院。";
    }
  };
  Covid19Nepal3Title = (e) => {
    switch (e) {
      case "eng":
        return "Nepal Pahse 3";
      case "chi":
        return "泥泊尔第三阶段";
    }
  };
  Covid19Nepal3 = (e) => {
    switch (e) {
      case "eng":
        return "Children clothes distributed to one orphanage home with 20 children.\nChildren clothes distributed to one children home with 15 children.\nFinancial support to 50 pastors.\nFood and blanket supplied to 149 families.";
      case "chi":
        return "孩童衣服分发至一家共有 20 名孩童的孤儿院。\n孩童衣服分发至一家共有 15 名孩童的儿童之家。\n财务资助 50 名牧者。\n食物及被单补给至 149 个家庭。";
    }
  };
  //ongoing
  OngoingTitle = (e) => {
    switch (e) {
      case "eng":
        return "Ongoing Ministries";
      case "chi":
        return "正在进行事工";
    }
  };
  OngoingBtn = (e) => {
    switch (e) {
      case "eng":
        return "Participate";
      case "chi":
        return "前往参与";
    }
  };
  SerojaCycloneFundTitle = (e) => {
    switch (e) {
      case "eng":
        return "Fund Raising for East Nusa Tenggara Province (Indonesia)\nDue to Seroja Cyclone";
      case "chi":
        return "为东努沙登加拉省(印尼)筹款\n因遭受热带气旋“塞罗亚”侵袭";
    }
  };
  SerojaCycloneFundContentA = (e) => {
    switch (e) {
      case "eng":
        return "In early April, Indonesia’s East Nusa Tenggara province was hit by Seroja Cyclone, which triggered floods, mudslides, and other disasters, causing local victims to lose their homes.\nMethodist Crisis Relief and Development (MCRD) decided to assist them in the following matters:";
      case "chi":
        return "在4月初，印尼东努沙登加拉省遭到热带气旋“塞罗亚”侵袭，引发了洪水、泥石流等多项灾难导致当地灾民失去家园。\n卫理救援赈灾事工（MCRD) 决定在以下事项援助他们：";
    }
  };
  SerojaCycloneFundContentB = (e) => {
    switch (e) {
      case "eng":
        return "Hygiene kit distribution\nBaby diapers and sanitary pads distribution\nReconstruction of houses";
      case "chi":
        return "卫生用品的分发\n婴儿纸尿裤和卫生巾的分发\n房屋重建";
    }
  };
  SerojaCycloneFundContentC = (e) => {
    switch (e) {
      case "eng":
        return "Therefore, MCRD initiated fundraising for East Nusa Tenggara Province, Indonesia. Anyone who donates at least RM 20 will get an MCRD T-shirt (postage not included). Please also send the transfer slip to +6 011-2906 5091\nBusiness Registration Number (BRN): Cac702501";
      case "chi":
        return "因此MCRD发起为印尼东努沙登加拉省筹款，凡捐款最少20令吉将获取MCRD T恤一件 (邮费另计)，也请把转账单据whatapps至+6 011-2906 5091\nBusiness Registration Number (BRN): Cac702501";
    }
  };
  IndiaCovid19FundTitle = (e) => {
    switch (e) {
      case "eng":
        return "Fund Raising for Covid-19 Pandemic in India";
      case "chi":
        return "为印度新冠疫情筹款";
    }
  };
  IndiaCovid19FundContentA = (e) => {
    switch (e) {
      case "eng":
        return "As the catastrophe of India’s 2nd wave of COVID-19 unfolds with 400,000 new cases everyday reaching over 20 million patients it is beyond the capacity of India’s public health system to cope with such devastating situation and many had lost their livelihood. MCRD will coordinate with local partner to distribute essential family food aid which cost 1,000 Indian rupees or equivalent to MYR 60 each to families in poverty. As the situation escalates, CAC MCRD appeals to your generosity to help our brothers and sisters in India";
      case "chi":
        return "相信大家都知道印度covid灾情惨重，患者已经超过两千万人，并且每日新增患者四十万人，医疗体系崩溃，民不聊生。MCRD将联合印度当地伙伴发放食物包约价值1000印度卢比，相等于马币60元支援他们关心的贫穷户。随着疫情逐渐恶化，MCRD呼吁您慷慨地帮助我们在印度的兄弟姐妹。";
    }
  };
  IndiaCovid19FundContentB = (e) => {
    switch (e) {
      case "eng":
        return 'Methodist Crisis Relief bank account details:\nAccount Name: "CAC MCR Fund"\nAccount No: 21215200101514, RHB Bank Berhad\nRef: COVID-19 India\nPls whatsapp your bank in slip to us at +6 011-2906 5091 for us to monitor incoming funds. Thanks.';
      case "chi":
        return 'Methodist Crisis Relief bank account details:\nAccount Name: "CAC MCR Fund"\nAccount No: 21215200101514, RHB Bank Berhad\nRef: COVID-19 India\n请 whatsapp 我们转账单据 +6 011-2906 5091，以方便我们做记录。 谢谢。';
    }
  };
  ChristmasGiftDonationTitle = (e) => {
    switch (e) {
      case "eng":
        return "Children's Chirstmas Gift Donation";
      case "chi":
        return "儿童圣诞节礼物捐赠";
    }
  };
  ChristmasGiftDonationContentA = (e) => {
    switch (e) {
      case "eng":
        return "Many children are stuck at home ever since the beginning of the pandemic, and children of refugees & orang asli are not excepted from this restriction. In partnership with various centres, MCRD will prepare presents for over 1700 children to ignite the wonderful Christmas joy in them once again🎄 With just RM20, you can give a Christmas present to the children to celebrate this season of love and joy together! 🎁";
      case "chi":
        return "从疫情开始，MCRD都有接触难民教会，也得知当中有许许多多的小朋友被困在家里无法得到欢乐。在来临的圣诞节🎄，MCRD将预备圣诞礼物给接近1700位小孩。您可以在这温馨的季节里透过RM20.00去赠送一份圣诞礼物给一位小孩，为难民和原住民小孩带来欢乐！邀请您与MCRD一起分享这一点点的爱，“疫”见礼物，小孩开心🎁";
    }
  };
  ChristmasGiftDonationContentB = (e) => {
    switch (e) {
      case "eng":
        return "Methodist Crisis Relief bank account details:\nAccount Name: CAC MCR Fund\nAccount No: 21215200101514, RHB Bank Berhad\nBusiness Registration Number (BRN): Cac702501\nPlease whatapps 011-2906 5091  (wa.link/1ezfzo) your transition slip for our record.";
      case "chi":
        return "Methodist Crisis Relief bank account details:\nAccount Name: CAC MCR Fund\nAccount No: 21215200101514, RHB Bank Berhad\nBusiness Registration Number (BRN): Cac702501\n请Whatapps至+6011 2906 5091 (wa.link/1ezfzo) 发送给我们您的转账单据，以便我们做记录。谢谢。";
    }
  };
  BantuanBanjirFundraisingTitle = (e) => {
    switch (e) {
      case "eng":
        return "Bantuan Banjir Fundraising";
      case "chi":
        return "Bantuan Banjir 筹款";
    }
  };
  BantuanBanjirFundraisingContentA = (e) => {
    switch (e) {
      case "eng":
        return "In response to recent floods happened across Malaysia, MCRD has expanded its flood relief operation from Klang to other areas such as\nSri Muda (Shah Alam), Taman Sri Nanding (Hulu Langat), Bentong, Mentakab, Karak and Sungai Lembing (Pahang). Expanding our operation means extending help to more disaster survivors to ease their difficulty, but it also means more operation’s cost at the same time. Besides covering our operation expenses, your donation will also go to our recovery projects for the disaster survivors, helping them to resume back to their normal living.";
      case "chi":
        return "马来西亚西马地区最近因接连豪雨，导致多个地区发生严重的水灾，因此MCRD 决定将救援赈灾事工从巴生扩展到其他地区，\n比如太子园（莎亚南）、斯里南丁（乌鲁冷岳）、文冬、文德甲、加叻和林明（彭亨）。扩大震灾行动也代表着我们需要更多的费用以及人力资源，因此您的捐款将让更多灾民收益，帮助他们更快地恢复正常的生活。 ";
    }
  };
  BantuanBanjirFundraisingContentB = (e) => {
    switch (e) {
      case "eng":
        return "Methodist Crisis Relief bank account details:\nAccount Name: CAC MCR Fund\nAccount No: 21215200101514, RHB Bank Berhad\nBusiness Registration Number (BRN): Cac702501\nPlease whatapps 011-2906 5091  (wa.link/1ezfzo) your transition slip for our record.";
      case "chi":
        return "MCRD Bantuan Banjir筹款活动资料:\n支票抬头请写: CAC MCR Fund\n账号: 21215200101514, RHB Bank Berhad\nBusiness Registration Number (BRN): Cac702501\n请Whatapps至+6011 2906 5091 (wa.link/1ezfzo) 发送给我们您的转账单据，以便我们做记录。谢谢。";
    }
  };
  //getInvolved
  PrayerSupportTitle = (e) => {
    switch (e) {
      case "eng":
        return "Prayer Support";
      case "chi":
        return "代祷支持";
    }
  };
  PrayerSupportSubtitle = (e) => {
    switch (e) {
      case "eng":
        return "We need your prayer";
      case "chi":
        return "我们需要你的祷告";
    }
  };
  PrayerContent = (e) => {
    switch (e) {
      case "eng":
        return "Pray for Victims of Seroja Cyclone at Nusa Tenggara Tengah, Indonesia.\nPray for victims of Covid-19 Pandemic in India.";
      case "chi":
        return "为着在印尼东努沙登加拉省遭受气旋“塞罗亚”冲击的灾民祷告\n为着印度因新冠病毒再度爆发受牵连的灾民祷告。";
    }
  };
  OfferingSupportTitle = (e) => {
    switch (e) {
      case "eng":
        return "Offering Support";
      case "chi":
        return "奉献支持";
    }
  };
  OfferingSupportSubtitle = (e) => {
    switch (e) {
      case "eng":
        return " For where your treasure is, there your heart will be also";
      case "chi":
        return "你的财宝在哪里,你的心也在那里";
    }
  };
  /*Example = (e) => {
        switch(e) {
            case "eng":
                return "";
            case "chi":
                return "";
        }
    }*/
}
export default Language;
